import { buildJobPostingSlugWithIdentifier } from "#/lib/job-posting-routing";

export function toAppPath(path: string) {
  const normalizedPath = normalizeAppPath(path);

  if (normalizedPath === "/") {
    return {
      to: "/" as const,
    };
  }

  return {
    to: "/$" as const,
    params: {
      _splat: normalizedPath.slice(1),
    },
  };
}

export function toJobPosting(slug: string, shortId: string) {
  return {
    to: "/job/$slugWithIdentifier" as const,
    params: {
      slugWithIdentifier: buildJobPostingSlugWithIdentifier(slug, shortId),
    },
  };
}

function normalizeAppPath(path: string) {
  const trimmed = path.trim();

  if (!trimmed || trimmed === "/") {
    return "/";
  }

  const withLeadingSlash = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return withLeadingSlash.replace(/\/+$/g, "");
}
